import { FC } from 'react';

import { useQueryParams } from '@app/hooks';
import { generateRouteParams } from '@app/utils';
import { Route } from '@app/constants';

import { BrowseByDepartments } from './BrowseByDepartments';
import { BrowseByInstructors } from './BrowseByInstructors';
import { useDepartmentsInstructorsFetch } from './useDepartmentsInstructorsFetch';
import { BrowseByField } from './constants';

import './BrowseBy.scss';

interface BrowseByProps {
  fieldName: BrowseByField;
}

const renderMap = {
  departments: BrowseByDepartments,
  instructors: BrowseByInstructors,
};

export const BrowseBy: FC<BrowseByProps> = ({ fieldName }) => {
  const queryParams = useQueryParams();
  const resource = useDepartmentsInstructorsFetch(fieldName);

  const getSearchPath = (search: string) =>
    generateRouteParams({
      pathname: Route.courseReserves,
      query: {
        ...queryParams,
        search,
      },
    });

  if (!resource?.data || queryParams?.search) {
    return null;
  }

  const Component = renderMap[fieldName];

  return <Component records={resource.data} getSearchPath={getSearchPath} />;
};
